<!--
Component that can show a Javascript object, formatted with JSON to make it easier
to read, inside of a panel that can be collapsed/expanded. This is useful during
development work to view a component's props or other data.
-->
<template>
  <pre class="collapse">
    <div @click="togglePre">+</div>
    {{ JSON.stringify(data, null, 2) }}
  </pre>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    togglePre(event) {
      event.target.parentElement.classList.toggle('collapse');
    }
  }
};
</script>
<style lang="scss" scoped>
pre {
  position: relative;
  div {
    position: absolute;
    top: 0;
    right: 0;
    font-weight: bold;
    line-height: 1.2rem;
    cursor: pointer;
  }
  &.collapse {
    max-height: 2rem;
    padding: 0;
    overflow: hidden;
    display: block;
  }
}
</style>
